import { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-location';
import Carousel from '../Carousel';
import CarouselMobile from '../CarouselMobile';
import Presentation from "../Presentation";
import useIsMobile from '../Layout/useIsMobile';

import './PageHome.scss';

export const PageHome = () => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const projectsRef = useRef(null);
  const cards = [
    {
      alt: "Blissim Gift project carousel image",
      classSuffix: "blissim-gift",
      image: "/images/Blissim/Gift/blissim-gift-carousel.svg",
      name: "Blissim Gift",
      url: "/projet/blissim-gift",
    }, {
      alt: "Blissim RGPD project carousel image",
      classSuffix: "blissim-rgpd",
      image: "/images/Blissim/RGPD/blissim-rgpd-carousel.svg",
      name: "Blissim RGPD",
      url: "/projet/blissim-rgpd",
    }, {
      alt: "Indigo Neo project carousel image",
      classSuffix: "indigo-neo",
      image: "/images/IndigoNeo/indigo-neo-carousel.svg",
      name: "Indigo Neo",
      url: "/projet/indigo-neo",
    }, {
      alt: "O Revoir project carousel image",
      classSuffix: "o-revoir",
      image: "/images/ORevoir/o-revoir-carousel.svg",
      name: "O Revoir",
      url: "/projet/o-revoir",
    }, {
      alt: "Identité visuelle project carousel image",
      classSuffix: "visual-identity",
      image: "/images/VisualIdentity/visual-identity-carousel.svg",
      name: "Identité visuelle",
      url: "/projet/identite-visuelle",
    }
  ];

  useEffect(() => {
    const splittedUrl = location.current?.href?.split("#");

    if (splittedUrl?.[1] === "projets" && projectsRef.current) {
      setTimeout(() => window.scrollTo({ top: projectsRef.current.offsetTop, behavior: "smooth" }), 100);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  });

  return (
    <div className="home-page">
      <Presentation
        alt="Homepage icon"
        buttons={[
          { link: "/#projets", linkType: "internal", text: "VOIR LES PROJETS", type: "white" },
          { link: "/a-propos#contact", linkType: "internal", text: "CONTACT", type: "transparency" },
        ]}
        classSuffix="home"
        description={"J’aide les entreprises à <div class='words'><span>concevoir des expériences simples et efficaces.</span><span>transformer les besoins en solutions concrètes.</span><span>faire de l’utilisateur un moteur stratégique.</span><span>explorer et choisir la meilleure voie.</span><span>concevoir des expériences simples et efficaces.</span></div>"}
        image={isMobile ? "/images/VisualIdentity/icon-mobile.svg" : "/images/VisualIdentity/icon.svg"}
        title="UX/UI Designer"
      />
      <div
        className="home-page__content"
        style={{ backgroundImage: isMobile ? "" : "url('/images/Home/home-background.svg')" }}
      >
        <section className="portrait">
          <div className="home-portrait-wrapper">
            <img className="home-portrait" src={`images/Home/lea-picault-home${isMobile ? '-mobile' : ''}.png`} alt="Léa Picault" />

            <div>
              <h2 className="home-portrait__title">Léa PICAULT</h2>
              <h3 className="home-portrait__subtitle">PRODUCT DESIGNER & UX / UI</h3>
              <p className="home-portrait__presentation">
                Un design, ce n’est jamais juste une jolie maquette. C’est une intention, un contexte,
                un problème à résoudre.
              </p>
              <p className="home-portrait__objective">👉 Objectif : capter rapidement l’attention sans trop en dire.</p>

              <Link className="button button__dark" to="/a-propos">
                EN SAVOIR PLUS
              </Link>
            </div>
          </div>
        </section>

        <section className="projects" id="projets" ref={projectsRef}>
          <h1 className="projects__title">Les projets</h1>

          {!isMobile && <Carousel cards={cards} />}
          {isMobile && <CarouselMobile cards={cards} />}
        </section>

        <section className="about-collaboration">
          <h3 className="about__collaboration-catch-phrase">👋 Une envie de collaborer ?<br />N’hésitez pas à me contacter ou à consulter mes projets.</h3>
          <Link className="button button__dark" to="/a-propos#contact">
            CONTACT
          </Link>
        </section>
      </div>
    </div>
  );
}

export default PageHome;